import React from 'react';
import glamorous from 'glamorous';
import ImgWithSource from './img-with-source';
import ensureFilesInPlaceImg from '../../../assets/images/docs/ensure-files-inplace/ensure-files-inplace.png';
import { MENU_ENTRIES } from './constants';

const EnsureXmlAndImages = ({ onSectionChange }) => {
  return (
    <div>
      <h3>
        STEPS 3 AND 4: ENSURING ALL XML AND IMAGE FILES ARE IN ONE FOLDER
      </h3>
      <p>
        Ensure that all XML files and the corresponding image files to be uploaded to the <i>GlobalRecalls</i> portal
        are
        placed in the one folder. The image file names MUST match exactly to the image file names entered into the XML
        file. For more information, see section: <a
        onClick={e => onSectionChange(MENU_ENTRIES.complexFieldImages)}>Images</a>.
      </p>
      <div>
        <glamorous.Div css={{marginBottom: 10}}>
          Below is an example of a folder containing XML files and its corresponding images:
        </glamorous.Div>
        <ImgWithSource src={ensureFilesInPlaceImg}/>
      </div>
      <br/>
      <div className="pt-callout pt-intent-warning pt-icon-info-sign">
        <h5 className="pt-callout-title">IMPORTANT</h5>
        While the image files do not need to be large, they do need to be clear. An image is often the most effective
        way to identify a recalled product. If the images are not clear, discuss the issue with the original party who
        submitted the recall, and request clearer images.
      </div>
    </div>
  );
};

export default EnsureXmlAndImages;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/ensure-files-inplace.js